import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const cmpVelocityRoute: InvariantJiraRoute = {
	name: 'software-reports-velocity-cmp',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/velocity',
};
